import { combineReducers } from 'redux';

import {
  RegisterAction,
  RegisterPayload,
} from '../types';
import {
  registerFail,
  registerRequest,
} from '../actions';

const productCode = (state = 'subscription-pay-as-you-go', action: RegisterAction) => {
  switch (action.type) {
    case registerRequest.type:
      return action.payload.productCode;

    case registerFail.type:
      return '';

    default:
      return state;
  }
};

const firstName = (state = '', action: RegisterAction) => {
  switch (action.type) {
    case registerRequest.type:
      return action.payload.firstName;

    case registerFail.type:
      return '';

    default:
      return state;
  }
};

const lastName = (state = '', action: RegisterAction) => {
  switch (action.type) {
    case registerRequest.type:
      return action.payload.lastName;

    case registerFail.type:
      return '';

    default:
      return state;
  }
};

const email = (state = '', action: RegisterAction) => {
  switch (action.type) {
    case registerRequest.type:
      return action.payload.email;

    case registerFail.type:
      return '';

    default:
      return state;
  }
};

const password = (state = '', action: RegisterAction) => {
  switch (action.type) {
    case registerRequest.type:
      return action.payload.password;

    case registerFail.type:
      return '';

    default:
      return state;
  }
};

const promoCode = (state = '', action: RegisterAction) => {
  switch (action.type) {
    case registerRequest.type:
      return action.payload.promoCode;

    case registerFail.type:
      return '';

    default:
      return state;
  }
};

export default combineReducers<RegisterPayload>({
  productCode,
  firstName,
  lastName,
  email,
  password,
  promoCode,
});
